import React from "react";
import Header from "../component/common/header";
import Footer from "../component/common/footer";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { TypeAnimation } from "react-type-animation";
import { Collapse, message } from "antd";

import "./style.scss";

const HomePage = () => {
  const { Panel } = Collapse;

  const onChange = () => { };

  return (
    <>
      <Header />
      <section className="feature-banner" id="tarotx">
        <div className="blur-header">
          <img className="treeLeaves" src="./images/BG-header.png" alt="" />
        </div>

        <div className="container">
          <div className="main-banner">
            <div className="title">
              <TypeAnimation
                style={{
                  whiteSpace: "pre-line",
                  height: "225px",
                  width: "70%",
                  display: "block",
                  margin: "auto",
                }}
                sequence={[
                  "Discover Your Future",
                  1000,
                  `Discover Your Future with AI-Powered Tarot Readings`,
                  1000,
                  "Discover Your Future",
                  1000,
                  `Discover Your Future with AI-Powered Tarot Readings`,
                  1000,
                ]}
                wrapper="span"
                speed={30}
                repeat={Infinity}
              />
            </div>

            <div className="button-mystery">
              <button className="btn-mystery">
                <a
                  href="https://t.me/tarot_x_ai_bot"
                  target="_blank"
                  className="colum w-3 cc"
                >Start Your Free Reading</a>
              </button>
            </div>
            <section className="section-pool-info">
              <div
                className="wrap-pool-info"
                data-aos="fade-up"
                data-aos-duration="2000"
              >
                <div className="row-contract">
                  <p>Contract: 0x38686E219b59187C06d2DAB0C827c9cB0c780476</p>
                  <div className="icon">
                    <CopyToClipboard
                      text={`0x38686E219b59187C06d2DAB0C827c9cB0c780476`}
                      onCopy={() => {
                        message.success({
                          type: "success",
                          content: `Copied success`,
                          className: "custom-class",
                          duration: 2,
                        });
                      }}
                    >
                      <button className="btn-copy">
                        <img src="../images/copy.png" alt="" />
                      </button>
                    </CopyToClipboard>
                  </div>
                </div>
              </div>
            </section>
            {/* <div className="desc">COMING SOON</div> */}
            <div className="main-images-tarot">
              <div className="box-img-big">
                <img className="bg-img" src="./images/img-main.png" alt="" />
                <div className="box-img-small">
                  <img src="./images/img-small.png" alt="" />
                </div>
                <div className="box-img-gif">
                  <img src="./images/gif-main.gif" alt="" />
                </div>
              </div>
              <div className="blur-box">
                <img src="./images/Blur.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-destiny" id="features">
        <div className="container">
          <div className="wrap-destiny">
            <div className="title">Why Choose TarotXAI?</div>
            <div className="desc">
              Experience the future of Tarot readings with NFTs and blockchain
              technology.
            </div>
            <div className="guide-wrap">
              <div className="columns">
                <div className="colum w-5">
                  <div className="content-wrap">
                    <div className="icon">
                      <img src="./images/ai-pow.png" alt="" />
                    </div>
                    <div className="text">AI-Powered Tarot Insights</div>
                    <div className="txt">
                      Our advanced AI Agent learns from your queries to offer
                      deeper, more personalized readings.
                    </div>
                  </div>
                </div>
                <div className="colum w-5">
                  <div className="content-wrap">
                    <div className="icon">
                      <img src="./images/interactive.png" alt="" />
                    </div>
                    <div className="text">Interactive Tarot Experience</div>
                    <div className="txt">
                      Interactive and immersive card drawing experience.
                    </div>
                  </div>
                </div>
                <div className="colum w-5">
                  <div className="content-wrap">
                    <div className="icon">
                      <img src="./images/instant.png" alt="" />
                    </div>
                    <div className="text">Instant & On-Demand</div>
                    <div className="txt">
                      No waiting required. Get your reading anytime, anywhere.
                      Immediate insights from our AI Tarot.
                    </div>
                  </div>
                </div>
                <div className="colum w-5">
                  <div className="content-wrap">
                    <div className="icon">
                      <img src="./images/personal.png" alt="" />
                    </div>
                    <div className="text">Personalized Guidance</div>
                    <div className="txt">
                      Every reading is unique, just like you. Our AI Agent
                      remembers your preferences and tailors your experience.
                    </div>
                  </div>
                </div>
                {/* <div className="colum w-4">
                  <div className="content-wrap">
                    <div className="icon">
                      <img src="./images/svg-desc.png" alt="" />
                    </div>
                    <div className="text">Rewards System</div>
                    <div className="txt">
                      Earn and use TarotX tokens for transactions and rewards.
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-explore" id="howitworks">
        <div className="container">
          <div className="wrap-explore">
            <div className="title">How TarotXAI Works</div>
            <div className="desc">
              Experience the future of Tarot readings with NFTs and blockchain
              technology.
            </div>
            <div className="guide-wrap-explore">
              <div className="columns">
                <div className="colum w-5">
                  <div className="guide-explore">
                    <div className="content-flip">
                      <div className="box-img">
                        <img src="./images/topic.png" alt="" />
                      </div>
                      <div className="line-one lines"></div>
                      <div className="line-two lines"></div>
                      <div className="line-three lines"></div>
                      <div className="line-four lines"></div>
                      <div className="txt">Choose Your Topic</div>
                      <div className="desc-row">
                        Select from areas like Love, Career, Health, or ask a
                        custom question.
                      </div>
                    </div>
                  </div>
                </div>
                <div className="colum w-5">
                  <div className="guide-explore">
                    <div className="content-flip">
                      <div className="box-img">
                        <img src="./images/chat.png" alt="" />
                      </div>
                      <div className="line-one lines"></div>
                      <div className="line-two lines"></div>
                      <div className="line-three lines"></div>
                      <div className="line-four lines"></div>
                      <div className="txt">Chat with Our AI Agent</div>
                      <div className="desc-row">
                        Virtual shuffling and card selection.
                      </div>
                    </div>
                  </div>
                </div>
                <div className="colum w-5">
                  <div className="guide-explore">
                    <div className="content-flip">
                      <div className="box-img">
                        <img src="./images/receive.png" alt="" />
                      </div>
                      <div className="line-one lines"></div>
                      <div className="line-two lines"></div>
                      <div className="line-three lines"></div>
                      <div className="line-four lines"></div>
                      <div className="txt">Receive Personalized Guidance</div>
                      <div className="desc-row">
                        Get immediate insights and actionable guidance from the
                        AI Agent's interpretation.
                      </div>
                    </div>
                  </div>
                </div>
                <div className="colum w-5">
                  <div className="guide-explore">
                    <div className="content-flip">
                      <div className="box-img">
                        <img src="./images/save.png" alt="" />
                      </div>
                      <div className="line-one lines"></div>
                      <div className="line-two lines"></div>
                      <div className="line-three lines"></div>
                      <div className="line-four lines"></div>
                      <div className="txt">Save & Share Your Reading</div>
                      <div className="desc-row">
                        Save your readings for later reflection or share them
                        with friends and loved ones.
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="colum w-5">
                  <div className="guide-explore">
                    <div className="content-flip">
                      <div className="box-img">
                        <img src="./images/g-5.png" alt="" />
                      </div>
                      <div className="line-one lines"></div>
                      <div className="line-two lines"></div>
                      <div className="line-three lines"></div>
                      <div className="line-four lines"></div>
                      <div className="txt">Token Integration</div>
                      <div className="desc-row">
                        Use TarotX tokens within the platform.
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-guardians" id="agentTarot">
        <div className="container">
          <div className="guide-guardians">
            <div className="box-img">
              <img src="./images/BG-de.png" alt="" />
              <div className="img-center">
                <img
                  className="treeLeaves"
                  src="./images/img-center.png"
                  alt=""
                />
              </div>
            </div>
            <div className="title">Meet Your Personal AI Tarot Agent</div>
            <div className="desc">
              The AI Agent is your personal Tarot guide, drawing on ancient
              wisdom and modern AI technology to bring you the most insightful,
              relevant readings. Available 24/7 to answer your questions on
              love, career, finances, and more.
            </div>
            {/* <div className="is-comming">COMING SOON</div> */}
          </div>
          <div className="button-mystery">
            <button className="btn-mystery"><a
              href="https://t.me/tarot_x_ai_bot"
              target="_blank"
              className="colum w-3 cc"
            >Start Your Free Reading</a></button>
          </div>
        </div>
      </section>
      {/* <section className="section-tarot-work" id="work">
        <div className="container">
          <div className="guide-tarot-work">
            <div className="left">
              <div className="title">How TarotX Works?</div>
            </div>
            <div className="right">
              <div className="wrap-line">
                <div className="vector-line">
                  <img src="./images/vector.png" alt="" />
                </div>
                <div className="item">
                  <div className="images-eclip">
                    <img src="./images/eclip.png" alt="" />
                  </div>
                  <div className="background-line"></div>
                  <div className="number">01</div>
                  <div className="txt">Create an Account</div>
                  <div className="desc">Sign up and set up your profile.</div>
                </div>
                <div className="item">
                  <div className="images-eclip">
                    <img src="./images/eclip.png" alt="" />
                  </div>
                  <div className="background-line"></div>
                  <div className="number">02</div>
                  <div className="txt">Explore Readers</div>
                  <div className="desc">
                    Browse and choose from a list of verified Readers.
                  </div>
                </div>
                <div className="item">
                  <div className="images-eclip">
                    <img src="./images/eclip.png" alt="" />
                  </div>
                  <div className="background-line"></div>
                  <div className="number">03</div>
                  <div className="txt">Book a Session</div>
                  <div className="desc">
                    Instantly book a reading at your convenience
                  </div>
                </div>
                <div className="item">
                  <div className="images-eclip">
                    <img src="./images/eclip.png" alt="" />
                  </div>
                  <div className="background-line"></div>
                  <div className="number">04</div>
                  <div className="txt">Own NFTs</div>
                  <div className="desc">
                    Purchase, collect, and trade unique Tarot cards.
                  </div>
                </div>
                <div className="item">
                  <div className="images-eclip">
                    <img src="./images/eclip.png" alt="" />
                  </div>
                  <div className="background-line"></div>
                  <div className="number">05</div>
                  <div className="txt">Earn Rewards</div>
                  <div className="desc">
                    Use TarotX tokens for various platform benefits.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <section className="section-users">
        <div className="container">
          <div className="guide-user">
            <div className="title">What Our Users Are Saying</div>
            <div className="desc">
              Quotes and ratings from early adopters and satisfied users.
            </div>
            <div className="wrap-user">
              <div className="columns">
                <div className="colum w-4">
                  <div className="content-user">
                    <div className="box-user">
                      <div className="top-user">
                        <div className="img-user">
                          <img src="./images/user.png" alt="" />
                        </div>
                        <div className="text">
                          Michael L <span>TarotX User</span>
                        </div>
                      </div>
                      <div className="desc-user">
                        The AI Agent gave me clarity like no other Tarot reading
                        before. It felt so personalized!
                      </div>
                    </div>
                  </div>
                </div>
                <div className="colum w-4">
                  <div className="content-user">
                    <div className="box-user">
                      <div className="top-user">
                        <div className="img-user">
                          <img src="./images/sara.png" alt="" />
                        </div>
                        <div className="text">
                          Sarah K <span>TarotX User</span>
                        </div>
                      </div>
                      <div className="desc-user">
                        Fast, accurate, and always available. TarotXAI is my new
                        go-to for life's big questions.
                      </div>
                    </div>
                  </div>
                </div>
                <div className="colum w-4">
                  <div className="content-user">
                    <div className="box-user">
                      <div className="top-user">
                        <div className="img-user">
                          <img src="./images/aisha.png" alt="" />
                        </div>
                        <div className="text">
                          Aisha R <span>TarotX User</span>
                        </div>
                      </div>
                      <div className="desc-user">
                        I love how easy it is to interact with the AI. It feels
                        like a real conversation with a Tarot master!
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-booking">
        <div className="container">
          <div className="guide-booking">
            <div className="left">
              <div className="title">
                Start your Free Reading with TarotXAI Today!
              </div>
            </div>
            <div className="right">
              <div className="desc">
                Find clarity, insight, and guidance with your AI-powered Tarot
                guide.
              </div>
              <div className="button-booking">
                <button className="btn-booking"><a
                  href="https://t.me/tarot_x_ai_bot"
                  target="_blank"
                  className="colum w-3 cc"
                >Start Your Free Reading</a></button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-community">
        <div className="container">
          <div className="wrap-community">
            <div className="title">Join Our Community</div>
            <div className="desc">
              Be part of our vibrant community events and discussions.
            </div>
            <div className="guide-community">
              <div className="columns center">
                {/* <div className="colum w-3">
                  <div className="content-row">
                    <div className="item-social">
                      <div className="line-one lines"></div>
                      <div className="line-two lines"></div>
                      <div className="line-three lines"></div>
                      <div className="line-four lines"></div>
                      <div className="icon">
                        <img src="./images/s-1.png" alt="" />
                      </div>
                      <div className="text">Facebook</div>
                      <div className="number">240K Followers</div>
                    </div>
                  </div>
                </div> */}
                <a
                  href="https://x.com/tarotxai"
                  target="_blank"
                  className="colum w-3"
                  style={{ textDecoration: "none" }}
                >
                  <div className="content-row">
                    <div className="item-social">
                      <div className="line-one lines"></div>
                      <div className="line-two lines"></div>
                      <div className="line-three lines"></div>
                      <div className="line-four lines"></div>
                      <div className="icon">
                        <img src="./images/s-2.png" alt="" />
                      </div>
                      <div className="text">Twitter</div>
                      {/* <div className="number">240K Followers</div> */}
                    </div>
                  </div>
                </a>
                <a
                  href="https://t.me/portal_tarotxai"
                  target="_blank"
                  className="colum w-3"
                  style={{ textDecoration: "none" }}
                >
                  <div className="content-row">
                    <div className="item-social">
                      <div className="line-one lines"></div>
                      <div className="line-two lines"></div>
                      <div className="line-three lines"></div>
                      <div className="line-four lines"></div>
                      <div className="icon">
                        <img src="./images/s-3.png" alt="" />
                      </div>
                      <div className="text">Telegram</div>
                      {/* <div className="number">240K Followers</div> */}
                    </div>
                  </div>
                </a>
                {/* <div className="colum w-3">
                  <div className="content-row">
                    <div className="item-social">
                      <div className="line-one lines"></div>
                      <div className="line-two lines"></div>
                      <div className="line-three lines"></div>
                      <div className="line-four lines"></div>
                      <div className="icon">
                        <img src="./images/s-4.png" alt="" />
                      </div>
                      <div className="text">Instagram</div>
                      <div className="number">240K Followers</div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="FAQ">
        <div className="container">
          <div className="title">FAQ</div>
          <Collapse
            className="collapse"
            defaultActiveKey={["1"]}
            onChange={onChange}
          >
            <Panel
              className="custom-panel"
              header="How does the AI Agent select the Tarot cards?"
              key="1"
            >
              <p className="content">
                Our AI algorithm analyzes your question and chooses the most
                relevant cards from the deck
              </p>
            </Panel>
            <Panel
              className="custom-panel"
              header="Is TarotXAI free to use?"
              key="2"
            >
              <p className="content">
                Yes, we offer a free plan with limited features, but you can
                upgrade for a more personalized experience.
              </p>
            </Panel>
            <Panel header="Can I save my readings?" key="3">
              <p className="content">
                Yes, our platform allows you to save your readings and access
                them anytime.
              </p>
            </Panel>
          </Collapse>
        </div>
      </section>

      <div className="box-img-footer">
        <img src="./images/images-bottom.png" alt="" />
      </div>
      <Footer />
    </>
  );
};
export default HomePage;
